import Vue from "vue";

export default class FormHelper {
    static initRuntimeProperties(controls: any[], parentControl: any = null) {
        // Init runtime properties
        for (let control of controls) {
            Vue.set(control, "fullName", parentControl ? parentControl.fullName + "." + control.name : control.name);
            Vue.set(control, "dataSourceParameters", []);
            Vue.set(control, "isEditing", false);
            Vue.set(control, "validationErrors", []);
            Vue.set(control, "additionalValues", []);
            Vue.set(control, "isValueChangedOutside", false);
        }
    }

    public static getValidationErrors(validationState: any): any[] {
        let validationErrors: any[] = [];

        for (var propertyName in validationState) {
            if (validationState.hasOwnProperty(propertyName)) {
                for (let message of validationState[propertyName]) {
                    validationErrors.push({ name: propertyName, message: message });
                }
            }
        }

        return validationErrors;
    }

    public static isControlValidationError(controlName: string, validationErrors: any[]): boolean {
        return validationErrors.some(x => x.name === controlName);
    }

    public static getRequestVerificationToken(): string {
        return (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
    }

    public static showPassword(inputId: string) {
        let input: HTMLElement = document.querySelector("#" + inputId);
        input.setAttribute("type", input.getAttribute("type") === "password" ? "text" : "password");
    }

    static setFocus(contextElement: HTMLElement) {
        // Set focus on first input element
        let firstInput: HTMLElement = contextElement.querySelector("input");
        if (firstInput) {
            firstInput.focus();
        }
    }

    static removeFocus() {
        // Remove document focus
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }
}